import { post, get } from '../http.js'
export default {
  getCollapseList: (params) => {
    return post('/game/map/point', params)
  },
  getMapInfo: (params) => {
    return post('/game/maps', params)
  },
  getUserId: (params) => {
    return get('/game/map/user', params)
  },
  getUserMarks: (params) => {
    return get('/game/map/marks/' + params)
  },
  setUserMarks: (params) => {
    return post('/game/map/marks', params)
  },
  setMapData: (params) => {
    return post('/game/map/data', params)
  }
}
